'use client'
import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import MyImage from '@shared/components/myImage'
import rightIcon from '@assets/images/icon/right.svg'

function ChartFilter({ allData, setNewData, typeWiseRun, runs, currentTeamId }) {
  // ************* CONSTANTS *************
  const types = ['1s', '2s', '3s', '4s', '6s']

  const [currentTypes, setCurrentTypes] = useState(types)
  const [isAll, setIsAll] = useState(true)

  useEffect(() => {
    setCurrentTypes(types)
    setIsAll(true)
  }, [currentTeamId, typeWiseRun])

  // ************* FUNCTIONS *************

  // !FILTER DATA RUN WISE
  function handleShots(type) {
    if (type === 'All') {
      const newIsAll = !isAll
      setIsAll(newIsAll)
      setCurrentTypes(newIsAll ? types : [])
      setNewData(newIsAll ? allData : [])
    } else {
      const updatedTypes = currentTypes.includes(type) ? currentTypes.filter(t => t !== type) : [...currentTypes, type]

      const newIsAll = updatedTypes.length === types.length
      setIsAll(newIsAll)
      setCurrentTypes(updatedTypes)
      setNewData(allData.filter(d => updatedTypes.includes(d.type)))
    }
  }

  const countRuns = {
    '1s': 1,
    '2s': 2,
    '3s': 3,
    '4s': 4,
    '6s': 6
  }

  const borderColor = {
    '1s': '#0000FE',
    '2s': '#00FFFF',
    '3s': '#FEC200',
    '4s': '#FF29FF',
    '6s': '#FE0000'
  }

  return (
    <div>
      <Row className={`d-flex justify-content-center  my-4 ${styles.rowWrapper}`}>
        <Col md={4} xs={4} lg={4} xl={4} xxl>
          <div onClick={() => handleShots('All')} className={`d-flex align-items-center cursor-pointer justify-content-center mt-3 ${''}`}>
            <span className={styles.customRadio} style={{ backgroundColor: isAll && '#323842' }}>
              {isAll && <MyImage className={styles.icon} src={rightIcon} height={14} width={14} />}
            </span>
            <div className={`${styles.run} mx-1`}>All:- Runs {runs?.total}</div>
          </div>
        </Col>
        {types?.map((t, i) => {
          return (
            <Col md={4} xs={4} lg={4} xl={4} xxl key={i}>
              <div
                style={{ borderColor: `${borderColor[t]}` }}
                onClick={() => handleShots(t)}
                className={`d-flex py-1 cursor-pointer align-items-center justify-content-center mt-2 ${styles.filterBorder}`}>
                <span style={{ backgroundColor: `${currentTypes?.includes(t) ? borderColor[t] : ''}` }} className={styles.customRadio}>
                  {currentTypes?.includes(t) && <MyImage className={styles.icon} src={rightIcon} height={12} width={12} />}
                </span>
                <div className={`${styles.run} mx-1`}>
                  {t}:- {(typeWiseRun[t] || 0) * countRuns[t]} runs
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

ChartFilter.propTypes = {
  allData: PropTypes.object,
  setNewData: PropTypes.func,
  typeWiseRun: PropTypes.object,
  runs: PropTypes.object,
  currentTeamId: PropTypes.string
}

export default ChartFilter
